import { render, staticRenderFns } from "./input6Procesado.vue?vue&type=template&id=38c1dd3a&scoped=true"
import script from "./input6Procesado.vue?vue&type=script&lang=js"
export * from "./input6Procesado.vue?vue&type=script&lang=js"
import style0 from "./input6Procesado.vue?vue&type=style&index=0&id=38c1dd3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c1dd3a",
  null
  
)

export default component.exports